import React from "react"
import styled from "styled-components"
import { media } from "utils/Media"
import NewsletterSignup from "./NewsletterSignup"
import SocialImages from "components/FlexibleContent/Blocks/SocialImages"
import FooterSponsers from "./FooterSponsers"
import FooterApp from "./FooterApp"
import FooterMenus from "./FooterMenus"
import FooterText from "./FooterText"

const FooterBg = styled.div`
	background-color: ${props => props.theme.colors.tertiary};
	padding: 3rem 0;

	@media ${media.md} {
		padding: 2rem; 
	}

	@media ${media.lg} {
		padding: 2rem 4rem 4rem 4rem; 
	}
`

const Footer = (props) => {
	return(
		<footer>
			{/* {(props.hideSocial === "no" || props.hideSocial === null) &&  */}
				<SocialImages />
			{/* } */}
			{/* {(props.hideSignup === "no" || props.hideSignup === null) && */}
				<NewsletterSignup />
			{/* } */}
			<FooterSponsers />
			{/* <FooterApp /> */}
			<FooterBg>
				<FooterMenus />
				<FooterText />
			</FooterBg>
		</footer>
	)
}

export default Footer